'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import Box, { BoxProps } from '../../kit/box'
import Text from '../../kit/text'

/* -----------------------------------------------------------------------------
 * PageHeader
 * -------------------------------------------------------------------------- */

export type PageHeaderProps = BoxProps & {
  actions?: React.ReactNode
  eyebrow?: string
  title: string
}

function PageHeader({ actions, eyebrow, title, ...otherProps }: PageHeaderProps) {
  return (
    <Box
      alignItems={{ desktop: 'center' }}
      flexDirection={{ desktop: 'row' }}
      gap='16'
      mb='24'
      {...otherProps}
    >
      <Box flex='1 1 auto' minWidth={0}>
        {eyebrow ? (
          <Text font='pro.eyebrow.11' textColor='proTextFaint'>
            {eyebrow}
          </Text>
        ) : null}
        <Text font='pro.display.31.bold' mt='04' textColor='proInk'>
          {title}
        </Text>
      </Box>
      {actions ? (
        <Box alignItems='center' flexDirection='row' gap='08'>
          {actions}
        </Box>
      ) : null}
    </Box>
  )
}

export default PageHeader
